export default __webpack_public_path__ + "static/media/Head_1_Ear_2_C4.77f166cc.svg";